export const CollegiateEngravingResources = 'collegiate-engravings'
